"use client"
import React from "react";
import WaitListForm from "./Contact/WaitListForm";
import InlineWaitListForm from "./Contact/InlineWaitListForm";

export default function JoinPoln(props) {
    const {
        reverse = false,
        className = "red-color",
        text = "Join Waitlist",
        id = "consumer-join-poln",
        message = "Be the first to know when POLN is released",
        title = "Join our Wait List",
        actionText = "Done",
        successTitle = "Thank you for joining the waitlist!",
        successMessage = "Keep your eye on your inbox for updates and release date!",
        campaignName,
        logo,
        formType,
        htmlSuccessTitleHeading,
        questions,
        ...rest
    } = props

    //console.log("Text==>", text, "CTA", campaignName)

    const [waitList, setWaitList] = React.useState(false)

    const Form = formType === "inline" ? InlineWaitListForm : WaitListForm;

    return (<>

        <Form open={waitList}
              openDialog={() => setWaitList(true)}
              onClose={() => setWaitList(null)}
              title={title}
              reverse={reverse}
              className={className}
              text={text}
              id={id}
              campaignName={campaignName}
              message={message}
              actionText={actionText}
              successTitle={successTitle}
              successMessage={successMessage}
              htmlSuccessTitleHeading={htmlSuccessTitleHeading}
              logo={logo}
              questions={questions}
              {...rest}
        />
    </>);
}
